module.exports = __webpack_public_path__ + "static/media/meet_team_response.e9e72aeb.png";